import React, { useState } from 'react';
import { Table, Upload, Input, Button, Form } from 'antd';
import { v4 as uuidv4 } from 'uuid';
import { TableCard } from 'components';
import ImgCrop from 'antd-img-crop';

const EditableTable = () => {
  const [form] = Form.useForm();

  const handleSubmit = (values) => {
    const formData = new FormData();
    let keys = Object.keys(values);
    keys.map((item) => {
      if (item !== "image") {
        formData.append(item, values[`${item}`] || "");
      }
    });
    formData.append("image", values.image[0].originFileObj);
    console.log("formData", formData);
    console.log("values", values);
  };
  const handleFileChange = ({ fileList }) => {
    form.setFieldsValue({ image: fileList }); 
  };
 

  return (
    <>
    <TableCard>
      <Form form={form} onFinish={handleSubmit}>
        <Form.Item name="image">
          <ImgCrop>
            <Upload name="image" action="/upload" listType="picture" 
                maxCount={1} 
                fileList={form.getFieldValue("image")} onChange={handleFileChange}>
              <Button>Click to upload</Button>
            </Upload>
          </ImgCrop>
        </Form.Item>
        <Button  onClick={() => form.submit()}>Submit</Button>
      </Form>
    </TableCard>
  </>
  );
};

export default EditableTable;